import { apiPost } from './client'

/**
 * Butonul Connect - perechea lui `Remote_connect::create_device_session`
 * (fara tichet) si `Remote_connect::create_session` (de pe tichet), numai pe
 * RustDesk (decizia din 12 septembrie 2026: ScreenConnect e scos din uz):
 *
 *   POST /remote-connect/session  {device, ticket?}
 *
 * Raspunsul e acelasi contract vechi: un `hostUrlJoin` - adresa paginii de
 * lansare RustDesk (sub /app) - pe care ecranul il deschide. Un furnizor ramas
 * pe ScreenConnect primeste 409, cu mesajul de aratat omului.
 */
export type RemoteSessionAnswer = {
  tool: 'rustdesk'
  hostUrlJoin: string
}

export function createRemoteSession(device: number, ticket = 0): Promise<RemoteSessionAnswer> {
  const fields: Record<string, number> = { device }
  if (ticket > 0) fields.ticket = ticket
  return apiPost<RemoteSessionAnswer>('/remote-connect/session', fields)
}

/* --- Capetele marunte din fila Remote Connect a tichetului --------------- */

/** `Remote_connect::sendAgentDownloadLink`: linkul de instalare a agentului, catre proprietar. */
export function sendAgentDownloadLink(ticket: number, owner: number): Promise<{ status: string; sentTo?: string }> {
  return apiPost('/remote-connect/agent-link', { ticket, owner })
}

/**
 * `Remote_connect::downloadClient / downloadPutty`: fisierele din `download/`
 * ale portalului, servite de API (nu de CI3).
 */
export function remoteDownloadUrl(kind: 'client' | 'client-mac' | 'putty'): string {
  return `/api/v2/remote-connect/download/${kind}`
}
